import { Field } from 'formik';
import {  FormControl, Box, } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import PFSWrapper from '../components/ProgressiveFormStepper/PFSWrapper';
import { getQuestionParts,getColumns } from './utils';

const Multipart = ({ props, qObj, index, fieldName }) => {
  const questionParts = getQuestionParts(props,qObj,index);
  const columns = getColumns(qObj, questionParts);
  const hidden = typeof qObj.hidden === 'undefined' ? 'visible' : 'hidden';
  return (
    <Box >
      <ElementHeading qObj={qObj} props={props} />
      <ElementInstructions instructions={qObj.instructions} />
      <Box >
        <Field name={fieldName} visibilty={hidden}>
          {({ field, form }) => (
            <FormControl isInvalid={form.errors[fieldName] && form.touched[fieldName]}>
              <PFSWrapper props={props} groupedQuestions={questionParts} secOrIndIndex={index} isMultipart={true} columns={columns} />

              <ElementErrorMessage form={form} index={index} qid={qObj.qid} />
            </FormControl>
          )}
        </Field>
      </Box>
    </Box>
  );
};


export default Multipart;